module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"url_level_findings":"Url level findings","service":"Service","report_incorrect_finding":"Report incorrect finding"},"nl":{"url_level_findings":"Algemene bevindingen bij dit adres","service":"Dienst","report_incorrect_finding":"Meld incorrecte bevinding"}}')
  delete Component.options._Ctor
}
